export default "__VITE_ASSET__BRJW0MeB__"